export default __webpack_public_path__ + "static/DevPlant_logo-3486840530cd01f27287d94c48970f35.svg";